const auctionTypesIds = {
  publicId: '18965528-8421-42b6-bba3-e1bdf68f9335',
  privateId: 'c44474ab-a646-4dc9-be5e-512c65c8da68',
};

export default auctionTypesIds;
